export default __webpack_public_path__ + "static/media/errorFilledOrange.6212ed45.svg";